import { validations } from "@/utils/validationUtils";
import { NamePath } from "@rc-component/form/es/interface";
import { Form, Input } from "antd";

interface Props {
  name: NamePath;
  initialValue?: any;
}

const HiddenInput = ({ name, initialValue }: Props) => (
  <Form.Item name={name} rules={[validations.none]} initialValue={initialValue} hidden noStyle>
    <Input type="hidden" />
  </Form.Item>
);

export default HiddenInput;
